import React from 'react'
import logo from './../images/flat-design-no-data-illustration/9169232.jpg'
const Fallback = () => {
  return (
    <div className='flex justify-center '>
      <img  className='h-1/2 w-1/2' src={logo} alt="404 not found"/> 
    </div>
  )
}

export default Fallback
